import { Component, Input, OnInit } from '@angular/core';
import { Diet, Meal } from 'src/app/interfaces/diet';
import { DietService } from 'src/app/services/diet.service';
import { StateService } from 'src/app/services/state.service';

@Component({
  selector: 'app-meal-detail',
  templateUrl: './meal-detail.component.html',
  styleUrls: ['./meal-detail.component.scss'],
})
export class MealDetailComponent implements OnInit {
  @Input() date!: string;
  diet!: Diet;

  constructor(
    private stateService: StateService,
    private dietService: DietService
  ) {}

  ngOnInit(): void {
    this.getMealDetail();
  }

  getMealDetail() {
    this.dietService
      .getDietDetail(this.stateService.selectedDiet?.id!, this.date)
      .subscribe((diet: any) => {
        this.diet = diet;
      });
  }
}
